import { useState, useEffect } from 'react';

export function useViewportAspectRatio() {
  const [is916, setIs916] = useState(false);

  useEffect(() => {
    const checkAspectRatio = () => {
      const aspectRatio = window.innerHeight / window.innerWidth;
      setIs916(Math.abs(aspectRatio - (16 / 9)) < 0.01); // Allow some tolerance
    };

    checkAspectRatio();
    window.addEventListener('resize', checkAspectRatio);

    return () => window.removeEventListener('resize', checkAspectRatio);
  }, []);

  return is916;
}
